

/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "components/CustomButtons/Button.js";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CustomInput from "components/CustomInput/CustomInput.js";
import Slide from "@material-ui/core/Slide";

// sections for this page
import SectionDescription from "views/PresentationPage/Sections/SectionDescription.js";
import SectionFooter from "views/footer/PageFooter.js"

import presentationStyle from "assets/jss/material-kit-pro-react/views/echosup/ProfessionnalisationStyle.js";

import logo_ecosup from "assets/img/ecosup.png"

import logo_oeuf from "assets/img/visuel_oeuf_2023.png"
import ProfessionnalisationPage from "./ProfessionnalisationPage";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles(presentationStyle);

export default function FormOfferPage() {

  const formationTypeMap = {
    assistante_dentaire: "Assistant(e) dentaire",
    aepe: "Accompagnant(e) éducatif petite enfance",
    assistant_juridique: "Assistant(e) juridique",
    auxiliaire_veterinaire: "Auxiliaire de service vétérinaire",
    secretaire_medicale: "Secrétaire médical(e)",
  };

  const typeTypeMap = {
    professionnalisation: "Professionnalisation",
    apprentissage: "Apprentissage",
  };


  const [isLoading, setIsLoading] = useState(false);
  const [offers, setOffers] = useState([]);
  const [modalApply, setModalApply] = React.useState(false);

  useEffect(() => {
    setIsLoading(true)
    axios.get(`${global.API_URL}/contrats`)
      .then(res => {
        console.log(res.data);
        let offers = res.data;
        offers.sort((a, b) => new Date(a.created_at) > new Date(b.created_at) ? -1 : 1);

        setOffers(offers);
        console.log(offers)
        setIsLoading(false)
      });
  }, []);

  const [data, setData] = useState({ nom: "", prenom: "", email:"", phone:"", texte:""});
  const [errors, setErrors] = useState({});
  function handleValidation(){
    let formIsValid = true;
    let errors = {};

    //Name
    let name = `${data.nom}`;
    if(name.trim() == ""){
       formIsValid = false;
       errors["name"] = "*Veuillez entrer un nom";
    }else{
      if(typeof name !== "undefined"){
         if(!name.match(/^[a-zA-Z]+$/)){
            formIsValid = false;
            errors["name"] = "*Le nom doit comporter uniquement des caratères";
         }
      }
    }

    //Prenom
    let prenom = `${data.prenom}`;
    if(prenom.trim() == ""){
       formIsValid = false;
       errors["prenom"] = "*Veuillez entrer un prénom";
    }else{
      if(typeof prenom !== "undefined"){
         if(!prenom.match(/^[a-zA-Z]+$/)){
            formIsValid = false;
            errors["prenom"] = "*Le prénom doit comporter uniquement des caratères";
         }
      }
    }

    //Email
    let email = `${data.email}`;
    if(email.trim() == ""){
       formIsValid = false;
       errors["email"] = "*Veuillez entrer une adresse email";
    }else{
      if(typeof email !== "undefined"){
         let lastAtPos = email.lastIndexOf('@');
         let lastDotPos = email.lastIndexOf('.');

         if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
            formIsValid = false;
            errors["email"] = "*Veuillez entrer une adresse email valide";
          }
     }
    }

    //Phone
    let phone = `${data.phone}`;
    if(phone.trim() == ""){
       formIsValid = false;
       errors["phone"] = "*Veuillez entrer un numéro de téléphone";
    }else{
      if(typeof phone !== "undefined"){
         if(!phone.match(/^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/)){
            formIsValid = false;
            errors["phone"] = "*Veuillez entrer un numéro de téléphone valide";
         }
      }
    }

    //text
    let texte = `${data.texte}`;
    if(texte.trim() == ""){
       formIsValid = false;
       errors["texte"] = "*Veuillez remplir votre message";
    }

    if(!checkbox){
      formIsValid = false;
      errors["checkbox"] = "*Veuillez acceptez l'enregistrement de vos informations";
    }

   setErrors(errors);
   console.log(errors);
   return formIsValid;
  }

  const [checkbox, setCheckbox] = useState(false);
  const handleCheckbox = (event) => {
    errors["checkbox"]="";
    setCheckbox(event.target.checked);
  };

  const [selectedOffer, setSelectedOffer] = useState();
  function openDialog(offer){
    setSelectedOffer(offer);
    setModalApply(true);
  }

  const [isPosting, setIsPosting] = useState(false);
  function apply(){
    let isValid = handleValidation();
    if(isValid){
      setIsPosting(true);
      const dataForm = new FormData();
      dataForm.append('data', JSON.stringify({
           nom: `${data.nom}`,
           prenom: `${data.prenom}`,
           email: `${data.email}`,
           phone: `${data.phone}`,
           texte: `OFFER${selectedOffer.id}${data.texte}`
         }))
  
      axios.post(`${global.API_URL}/messages`,dataForm
      ).then(function(response){
      console.log('Success!');
      setIsPosting(false);
      setModalApply(false);
      setModalSuccess(true);
    })
    .catch(function(){
      console.log('Fail!');
    });
    }
  }

  const [modalSuccess, setModalSuccess] = React.useState(false);

  const classes = useStyles();
  return (
    <div>
      <Header
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 50,
          color: "white"
        }}
      />
      <Parallax
        image={require("assets/img/form.jpg")}
        className={classes.parallax}
        filter="dark"
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <GridContainer justify="center" alignItems="center">
                  <GridItem xs={8} sm={4} md={4}>
                    <img
                      src={logo_ecosup} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={8} md={8}>
                    <h2 className={classes.title}>
                      Nos offres d'emploi
                    </h2>
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
  <div className={classes.section}>
    <div className={classes.container}>
      {isLoading ? (
        <GridContainer direction="row" justify="center" alignItems="center">
          <GridItem xs={12} sm={1} md={1}>
            <CircularProgress color="inherit" />
          </GridItem>
          <GridItem xs={12} sm={11} md={11}>
            <h3 className={classes.titleLoading}>
              Chargement des offres d'emploi. Veuillez Patientez ...
            </h3>
          </GridItem>
        </GridContainer>
      ) : offers && offers.length > 0 ? (
        offers.map((offer) => {
          const createdAt = new Date(offer.created_at).toLocaleDateString();
          const formationType =
            offer.formation && formationTypeMap[offer.formation.type]
              ? formationTypeMap[offer.formation.type]
              : offer.formation && offer.formation.type;
          const typeType =
            offer.type && typeTypeMap[offer.type.type]
              ? typeTypeMap[offer.type.type]
              : offer.type && offer.type.type;
          return (
            <div key={offer.id} style={{ marginBottom: "20px" }}>
              <h3 className={classes.title_sub}>{offer.profil}</h3>
              <h4 className={classes.description_sub2}>
                Description: {offer.description}
              </h4>
              <p className={classes.description_sub}>Durée: {offer.duree}</p>
              <p className={classes.description_sub}>
                Formation: {formationType}
              </p>
              <p className={classes.description_sub}>Type: {typeType}</p>
              <br />
              <p className={classes.description_sub2}>
                Postée le: <b>{createdAt}</b>
              </p>
              <br/>
              <Button color="info" round onClick={() => {openDialog(offer)}}>
                   Candidater
                </Button>
              <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
            </div>
          );
        })
      ) : (
        <h3 className={classes.titleLoading}>
          Aucune offre d'emploi trouvée.
        </h3>
      )}
    </div>
  </div>
</div>

        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal
          }}
          open={modalApply}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setModalApply(false)}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description"
          maxWidth="md"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
        <h4 className={classes.modalTitle}>Candidature à l'offre d'emploi:</h4>
        {selectedOffer && <p className={classes.description}>{selectedOffer.profil}</p>}
        </DialogTitle>
        <DialogContent
          id="modal-slide-description"
          className={classes.modalBody}
        >
        <FormControl fullWidth className={classes.selectFormControl}>
          </FormControl>
          <p style={{color: "red",fontSize: "12px"}}>{errors["select"]}</p>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <CustomInput
                labelText="Nom"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, nom: e.target.value });errors["name"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["name"]}</p>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <CustomInput
                labelText="Prénom"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, prenom: e.target.value });errors["prenom"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["prenom"]}</p>
            </GridItem>
          </GridContainer>
              <CustomInput
                labelText="Téléphone"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, phone: e.target.value });errors["phone"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["phone"]}</p>
              <CustomInput
                labelText="Email"
                id="float"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: (e) => {setData({ ...data, email: e.target.value });errors["email"]=""},
                  required: true}}
              />
            <p style={{color: "red",fontSize: "12px"}}>{errors["email"]}</p>
            <CustomInput
                    labelText="Votre message"
                    id="float"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: (e) => {setData({ ...data, texte: e.target.value });errors["texte"]=""},
                      multiline: true,
                      rows: 5
                    }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    onChange={handleCheckbox}
                  />
                }
                label="J'accepte l'enregistrement de mes informations dans la base de données de l'école."
              />
              <p style={{color: "red",fontSize: "12px"}}>{errors["checkbox"]}</p>
              <p className={classes.rgpd}>Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par Ecosup Toulon pour vous tenir informés d'informations importantes relatives à votre admissibilité. Elles sont conservées pendant 1 an et sont destinées au service des admissions. Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en contactant : contact@ecosup-toulon.fr Nous vous informons de l’existence de la liste d'opposition au démarchage téléphonique « Bloctel », sur laquelle vous pouvez vous inscrire ici : https://conso.bloctel.fr/</p>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button onClick={() => {apply()}} color="info" round>
            {isPosting ? "Veuillez patienter ... " : "Envoyer"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal
          }}
          open={modalSuccess}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setModalSuccess(false)}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
          <h4 className={classes.modalTitle}>Votre candidature a bien été envoyée!</h4>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
          >
            <p>Un membre de notre équipe vous contactera dans les plus bref délais.</p>
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            <Button onClick={() => {setModalSuccess(false)}} color="info" round>Retour</Button>
          </DialogActions>
        </Dialog>

      <SectionFooter date={"11 Février 2026"}/>
    </div>
  );
}

